import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { bootstrapI18n } from '@vendasta/galaxy/i18n';
import { LEXICON_FILE_FORMAT_OPTION } from '@galaxy/lexicon';
import { enableMocksIfNeeded, reportToHeimdall } from '@vendasta/core';
import { AppModule } from './app/app.module';
import { devServer, environment } from './globals';
import En from './assets/i18n/en_devel.json';
import { Network } from '@capacitor/network';
import { Capacitor } from '@capacitor/core';

if (!devServer) {
  enableProdMode();
}

const getNetworkStatus = async () => {
  const status = await Network.getStatus();
  if (!status.connected) {
    alert('You are not connected to the internet. Please check your network settings and open the app again.');
    navigator['app'].exitApp();
  }
};

if (Capacitor.isNativePlatform()) {
  getNetworkStatus();
}

const WEBLATE_COMPONENT_NAME = 'business-center/business-center-client';
const BASE_TRANSLATIONS = En;
bootstrapI18n(
  WEBLATE_COMPONENT_NAME,
  BASE_TRANSLATIONS,
  null,
  LEXICON_FILE_FORMAT_OPTION.NESTED_JSON,
  false,
  environment,
);

async function bootstrap() {
  await enableMocksIfNeeded();

  platformBrowserDynamic()
    .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
    .catch((err) => {
      reportToHeimdall(err);
      console.error(err);
    });
}

bootstrap();
